/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export type {
  Sum,
  LastValue,
  Histogram,
  ExponentialHistogram,
} from './aggregator/types';

export type {
  AggregationSelector,
  AggregationTemporalitySelector,
} from './export/AggregationSelector';

export { AggregationTemporality } from './export/AggregationTemporality';

export { DataPointType, InstrumentType } from './export/MetricData';
export type {
  DataPoint,
  SumMetricData,
  GaugeMetricData,
  HistogramMetricData,
  ExponentialHistogramMetricData,
  ResourceMetrics,
  ScopeMetrics,
  MetricData,
  MetricDescriptor,
  CollectionResult,
} from './export/MetricData';

export type { PushMetricExporter } from './export/MetricExporter';

export { MetricReader } from './export/MetricReader';
export type { IMetricReader, MetricReaderOptions } from './export/MetricReader';

export { PeriodicExportingMetricReader } from './export/PeriodicExportingMetricReader';
export type { PeriodicExportingMetricReaderOptions } from './export/PeriodicExportingMetricReader';

export { InMemoryMetricExporter } from './export/InMemoryMetricExporter';

export { ConsoleMetricExporter } from './export/ConsoleMetricExporter';

export type {
  MetricCollectOptions,
  MetricProducer,
} from './export/MetricProducer';

export { MeterProvider } from './MeterProvider';
export type { MeterProviderOptions } from './MeterProvider';

export { AggregationType } from './view/AggregationOption';
export type { AggregationOption } from './view/AggregationOption';

export type { ViewOptions } from './view/View';

export type { IAttributesProcessor } from './view/AttributesProcessor';
export {
  createAllowListAttributesProcessor,
  createDenyListAttributesProcessor,
} from './view/AttributesProcessor';

export { TimeoutError } from './utils';
